import { ApiDocEndpoint, ApiHistoryEntry } from '@/types/ApiDocs.ts';

// ─── קבועים ────────────────────────────────────────────────────────────
export const LS_KEY = 'api_docs_history';
export const HISTORY_MAX_DAYS = 3;

export const METHOD_COLORS: Record<string, string> = {
    GET: 'bg-blue-100 text-blue-700 border-blue-200',
    POST: 'bg-green-100 text-green-700 border-green-200',
    PUT: 'bg-amber-100 text-amber-700 border-amber-200',
    PATCH: 'bg-purple-100 text-purple-700 border-purple-200',
    DELETE: 'bg-red-100 text-red-700 border-red-200',
};

// ─── היסטוריה ────────────────────────────────────────────────────────────
export function loadHistory(): ApiHistoryEntry[] {
    try {
        const raw = localStorage.getItem(LS_KEY);
        if (!raw) return [];
        const all: ApiHistoryEntry[] = JSON.parse(raw);
        const cutoff = Date.now() - HISTORY_MAX_DAYS * 24 * 60 * 60 * 1000;
        return all.filter((e) => e.timestamp >= cutoff);
    } catch {
        return [];
    }
}

export function saveHistory(entries: ApiHistoryEntry[]) {
    localStorage.setItem(LS_KEY, JSON.stringify(entries));
}

// ─── בניית דוגמאות קוד ───────────────────────────────────────────────────
export function buildCodeSnippets(
    endpoint: ApiDocEndpoint,
    token: string,
    paramVals: Record<string, string>,
) {
    let resolvedUrl = endpoint.url_pattern;
    const pathParams = endpoint.params_schema.filter((p) => p.in === 'path');
    pathParams.forEach((p) => {
        resolvedUrl = resolvedUrl.replace(`{${p.name}}`, paramVals[p.name] || `:${p.name}`);
    });

    const queryParams = endpoint.params_schema.filter((p) => p.in !== 'path' && endpoint.method === 'GET');
    const bodyParams = endpoint.params_schema.filter((p) => p.in !== 'path' && endpoint.method !== 'GET');

    const fullBase = `${window.location.origin}${resolvedUrl}`;

    const qp = new URLSearchParams();
    queryParams.forEach((p) => {
        const v = paramVals[p.name] || p.default || '';
        if (v) qp.set(p.name, v);
    });
    const qs = qp.toString() ? `?${qp.toString()}` : '';

    const bodyObj: Record<string, string> = {};
    bodyParams.forEach((p) => {
        const v = paramVals[p.name] || p.default || '';
        if (v) bodyObj[p.name] = v;
    });

    const authHeader = token ? `-H "Authorization: Token ${token}"` : '';

    let curlCode = `curl -X ${endpoint.method} "${fullBase}${qs}" \\\n  ${authHeader} \\\n  -H "Accept: application/json"`;
    if (endpoint.method !== 'GET' && Object.keys(bodyObj).length > 0) {
        curlCode += ` \\\n  -H "Content-Type: application/json" \\\n  -d '${JSON.stringify(bodyObj, null, 2)}'`;
    }

    let pythonCode = `import requests\n\nurl = "${fullBase}"\n`;
    if (token) pythonCode += `headers = {"Authorization": "Token ${token}", "Accept": "application/json"}\n`;
    else pythonCode += `headers = {"Accept": "application/json"}\n`;

    if (endpoint.method === 'GET') {
        const paramsStr = JSON.stringify(Object.fromEntries(qp), null, 4);
        pythonCode += `params = ${paramsStr}\n\nresponse = requests.get(url, headers=headers, params=params)\nprint(response.json())`;
    } else {
        pythonCode += `payload = ${JSON.stringify(bodyObj, null, 4)}\n\nresponse = requests.${endpoint.method.toLowerCase()}(url, headers=headers, json=payload)\nprint(response.json())`;
    }

    return { curl: curlCode, python: pythonCode };
}
